<h2 matDialogTitle class="mat-h2">Affiliate Details</h2>

<mat-dialog-content>
  <mat-divider></mat-divider>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">

    <ng-container matColumnDef="classicId">
      <th mat-header-cell *matHeaderCellDef>Classic ID</th>
      <td mat-cell *matCellDef="let row"> {{row.classicId}} </td>
    </ng-container>

    <ng-container matColumnDef="affiliate">
      <th mat-header-cell *matHeaderCellDef>Affiliate</th>
      <td mat-cell *matCellDef="let row">
        {{row.affiliate | titlecase}}
      </td>
    </ng-container>

    <ng-container matColumnDef="defaultUrl">
      <th mat-header-cell *matHeaderCellDef>Default URL</th>
      <td mat-cell *matCellDef="let row" style="word-break: break-all">
        {{row.defaultUrl | stripUrl}}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>

    <tr class="mat-mdc-row" *matNoDataRow>
      @if (isLoadingResults()) {
        <td class="mat-mdc-cell" [attr.colspan]="3">loading...</td>
      }
      @if (!isLoadingResults()) {
        <td class="mat-mdc-cell" [attr.colspan]="3">There are no active associated affiliates for this discount.</td>
      }
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20, 100]" pageSize="20" showFirstLastButtons></mat-paginator>
  <div class="button-group">
    <button mat-raised-button mat-dialog-close color="primary">Close</button>
  </div>
</mat-dialog-content>
